import { useStore } from "vuex";
import { ref, computed } from "vue";
import swalUtil from "@/utils/sweetalertUtil";
import { useRouter } from "vue-router";
import sweetalertUtil from '@/utils/sweetalertUtil'
import {useI18n} from 'vue-i18n'
// import {removeRememberUser, setRememberUser} from "@/modules/auth/store/getters";
import {removeRememberUser, setRememberUser} from "@/modules/principal/store/getters";
import { useGtm } from "@gtm-support/vue-gtm";
import catalogsService from "@/services/catalogsService";

const useAuthStore = () => {
  const router = useRouter();
  const store = useStore();
  const {t} = useI18n();
  const gtm = useGtm();

  const user = ref({
    phone: ''
  });
  const catalogs = ref([]);
  const questionnaires = ref([]);
  const keysError = ref({})
  const securityQuestions = ref({
    questions: [],
    user_id: null
  })

  const validQuestionsCode = ref(null)
  const showBusinessField = ref(false)
  const showLoginBusinessField = ref(false)

  // const matchFound = computed(() => store.getters['getPsyMatchesFound'])

  const rememberUserCheck = ref(false)
  const setp = ref("login");//login
  const dataLogin = ref({
    password: "",
    email_or_nomina: "",
    newPassword: "",
    securityCode: "",
    confirmPassword: "",
    business_name: ""
  });

  const b2bUser = ref({
    code: "",
    number_nomina: "",
    email : "",
    phone : "",
    password : "",
    confirmPassword: "",
    hasEmail: false
  })

  const relationships = ref([]);

  const reasons = computed(() => store.getters[`auth/getDataStoreByKey`]('reasons'));
  const partner = computed(() => store.getters[`auth/getDataStoreByKey`]('partner'));
  const answers = computed(() => store.getters[`auth/getDataStoreByKey`]('answers'));
  const isFamilyRoute = computed(() => store.getters['auth/getIsFamilyRoute'])

  const savesaveToStoreByKey = ({ data, key }, save = false) => {
    if (save) sessionStorage.setItem(key, JSON.stringify(data));
    store.commit(`auth/saveAuthStore`, { data, key });
  }

  const handleError = (title) => sweetalertUtil.fire({ icon: "error", title, timer: 3000 });

  const loginUser = async () => {

    if (rememberUserCheck.value) {
      setRememberUser(dataLogin.value.email_or_nomina.toLowerCase())
    } else {
      removeRememberUser()
    }

    const { email_or_nomina, password } = dataLogin.value;

    let res = await store.dispatch(`auth/loginUser`, { email_or_nomina, password });

    if (res.error) {

      if (res?.message == "name bussines is required") {
        showLoginBusinessField.value = true

        swalUtil.fire({
          icon: 'error',
          title: t('alert-title-message'),
          text: t('login.business-required-text'),
          showConfirmButton: false,
          timer: 3000
        })

        return;

      } else {
        return handleError(res.message);
      }
    }

    const loginModal = bootstrap.Modal.getOrCreateInstance(document.querySelector('#loginModal'))
    loginModal.hide()

    router.push({name: res.data.route_name_redirect})

    // const { role, configuration_check } = res.data

    // if (role === "Paciente") router.push({ name: "psicologists-options" });
    // else if (role === "Entrevistador") router.push({ name: "interviewer-index" });
    // else if (role === "Psicólogo") {
    //   if (configuration_check) {
    //     router.push({ name: "psycologist-configuration-availablity" });
    //   } else {
    //     router.push({ name: "psycologist-configuration-calendar-integration" });
    //   }
    // }
  };

  const sendCodeUser = async () => {

    store.commit('setGeneralIsLoading', true);

    // Set data if remember check is checked
    if (rememberUserCheck.value) {
      setRememberUser(dataLogin.value.email_or_nomina.toLowerCase())
    } else {
      removeRememberUser()
    }

    const recoverPassData = {
      email_or_number_nomina: dataLogin.value.email_or_nomina,
      business_name: dataLogin.value.business_name || null
    }

    const { data, error, message } = await store.dispatch(`auth/sendCodeUser`, recoverPassData);

    if (!error) {

      if (data.type_recovery == 'number_nomina') {

        securityQuestions.value.questions = data.question_securities
        securityQuestions.value.user_id = data.user_id
        setp.value = 'recover-questions';

      } else {
        setp.value = "recover";
      }

      store.commit('setGeneralIsLoading', false);

    } else {
      store.commit('setGeneralIsLoading', false);

      if (message == "name bussines is required") {
        showBusinessField.value = true

        swalUtil.fire({
          icon: 'error',
          title: t('alert-title-message'),
          text: t('login.business-required-text'),
          showConfirmButton: false,
          timer: 3000
        })

        return;
      } else {
        return handleError(message);
      }
    }
  };

  const sendSecurityQuestions = async () => {
    store.commit('setGeneralIsLoading', true);

    let securityQuestionsData = {
      questions: getAnswers(securityQuestions.value.questions),
      user_id: securityQuestions.value.user_id
    }

    const { data, error, message } = await store.dispatch(`auth/sendSecurityQuestions`, securityQuestionsData);

    if (!error) {

      validQuestionsCode.value = data.code
      setp.value = 'recover'
      store.commit('setGeneralIsLoading', false);

    } else {
      store.commit('setGeneralIsLoading', false);
      return handleError(message);
    }
  }

  const getAnswers = (questionsArr) => {
    let answers = []
    questionsArr.forEach(item => {
      answers.push({
        id: item.security_question_id,
        answer: item.answer
      })
    })
    return answers
  }

  const resetPass = async () => {
    store.commit('setGeneralIsLoading', true);

    // Set remember data
    if (rememberUserCheck.value) {
      setRememberUser(dataLogin.value.email_or_nomina.toLowerCase())
    } else {
      removeRememberUser()
    }

    const newPassData = {
      email: dataLogin.value.email_or_nomina,
      code: dataLogin.value.securityCode,
      password: dataLogin.value.newPassword
    }

    const res = await store.dispatch(`auth/resetPass`, newPassData);

    if(!res.error) {

      clearData(dataLogin.value)
      setp.value = "login";
      store.commit('setGeneralIsLoading', false);

      swalUtil.fire({
        icon: 'error',
        title: t('login.password-updated-title'),
        text: t('login.password-updated-text'),
        showConfirmButton: false,
        timer: 5000
      })

    } else {
      store.commit('setGeneralIsLoading', false);
      return handleError(res.message);
    }
  };

  const resetB2bPass = async () => {
    store.commit('setGeneralIsLoading', true);

    // Set remember data
    if (rememberUserCheck.value) {
      setRememberUser(dataLogin.value.email_or_nomina.toLowerCase())
    } else {
      removeRememberUser()
    }

    const newPassData = {
      user_id: securityQuestions.value.user_id,
      code: validQuestionsCode.value,
      password: dataLogin.value.newPassword
    }

    const { data, error, message } = await store.dispatch(`auth/resetB2bPass`, newPassData);

    if (!error) {
      clearData(dataLogin.value, 'b2b')

      setp.value = "login";
      store.commit('setGeneralIsLoading', false);

      swalUtil.fire({
        icon: 'error',
        title: t('login.password-updated-title'),
        text: t('login.password-updated-text'),
        showConfirmButton: false,
        timer: 5000
      })

    } else {
      store.commit('setGeneralIsLoading', false);
      return handleError(message);
    }
  }

  const getCatalogs = async () => {
    let res = await store.dispatch(`auth/getCatalogs`)
    if (res.error) return handleError(res.message);
    catalogs.value = res.data
  };

  const getQuestionnaires = async () => {
    let res = await store.dispatch(`auth/getQuestionnaires`)
    if (res.error) return handleError(res.message);
    questionnaires.value = res.data
  };

  const registerB2bUser = async (securityQuestionsAndAnswers = {}, tenant = null) => {
    store.commit('setGeneralIsLoading', true);
    b2bUser.value.isFamily = isFamilyRoute.value;
    const b2bDataUser = Object.assign({}, b2bUser.value)
    b2bDataUser.tenant = tenant;
    delete b2bDataUser.confirmPassword
    if (b2bUser.value.hasEmail) {
      console.log('ocupa preguntas');
      let answers = [
        {
          "security_question_id": securityQuestionsAndAnswers.firstQuestionId,
          "answer": securityQuestionsAndAnswers.firstAnswer,
          "security_question_number": 1
        },
        {
          "security_question_id": securityQuestionsAndAnswers.secondQuestionId,
          "answer": securityQuestionsAndAnswers.secondAnswer,
          "security_question_number": 2
        },
        {
          "security_question_id": securityQuestionsAndAnswers.thirdQuestionId,
          "answer": securityQuestionsAndAnswers.thirdAnswer,
          "security_question_number": 3
        }
      ];
      b2bDataUser.security_questions = answers;
    } else {

    }

    const { message, error, data } = await store.dispatch("auth/registerB2bUser", b2bDataUser)

    if (!error) {
      store.commit('setGeneralIsLoading', false);

      const registerModal = document.querySelector('#b2bRegisterModal')
      const modal = bootstrap.Modal.getOrCreateInstance(registerModal)
      modal.hide()
      const registerModalFamily = document.querySelector('#b2bRegisterFamilyModal')
      const modalFamily = bootstrap.Modal.getOrCreateInstance(registerModalFamily)
      modalFamily.hide()
      gtm.trackEvent({
        event: 'evLoginEmpresas',
        tarjeta_empresarial: b2bUser.value.code,
        no_nomina: b2bUser.value.number_nomina,
        num_whatsapp: b2bUser.value.phone,
        email: b2bUser.value.email

      });
      router.push({ name: 'waiting-room-index'})
    } else {
      store.commit('setGeneralIsLoading', false);

      swalUtil.fire({
        icon: "error",
        title: "Mensaje",
        html: message,
      });

      return { error: true };
    }
  }

  const registerUser = async () => {
    const prevData = JSON.parse(JSON.stringify({
      reasons: reasons.value,
      partner: partner.value,
      answers: answers.value,
    }))
    // user.value.psychologist_id = psychologistId.value
    user.value.reason_consultations = prevData.reasons
    user.value.reason_consultations_items = prevData.partner
    user.value.questionnaire_initial = prevData.answers.filter(i => !!i).map(i => ({ question_id: i.id, answer: String(i.currentSelected) }))

    user.value.birthdate = user.value.birthdate.replaceAll('/', '-')

    const { error, message } = await store.dispatch("auth/registerUser", user.value);
    if (!error) {
      store.commit('auth/clearReasonsPartnerAndAnwers');
      const registerModal = document.querySelector("#registerModal");
      const modal = bootstrap.Modal.getOrCreateInstance(registerModal);
      modal.hide();

      /* if (!matchFound.value) {
        const result = await swalUtil.fire({
          title: t('alert-title-message'),
          text: t('general-messages.no-psychologists'),
          icon: 'warning',
          allowOutsideClick: false,
          allowEscapeKey: false,
        })

        if (result.isConfirmed) {
          router.push('waiting-room')
        }
      } */


      return { error: false };
    } else {
      swalUtil.fire({
        icon: "error",
        title: "error",
        html: message,
      });
      return { error: true };
    }
  };

  const logout = () => {
    store.commit('auth/logout')
    // router.push({name: 'login-page'})
    router.push({name: 'landing-page'})
  }

  const clearData = (Obj, type = 'email') => {
    for(var key in Obj) {
      if (Obj[key] === 'email_or_nomina' && rememberUserCheck.value) continue
      Obj[key] = ""
    }

    if (type == 'b2b') {
      validQuestionsCode.value = null
      securityQuestions.value.questions = []
      securityQuestions.value.user_id = null
    }
  }

  const getRelationships = async () => {
    const { data:response } = await catalogsService.getRelationships();
    relationships.value = response.result.data.map(el => ({...el, text: el.relationships}));
  }

  return {
    answers,
    partner,
    reasons,
    catalogs,
    dataLogin,
    user,
    setp,
    questionnaires,
    keysError,
    rememberUserCheck,
    b2bUser,
    securityQuestions,
    showBusinessField,
    validQuestionsCode,
    showLoginBusinessField,
    isFamilyRoute,
    relationships,
    savesaveToStoreByKey,
    handleError,
    loginUser,
    sendCodeUser,
    resetPass,
    getCatalogs,
    getQuestionnaires,
    registerUser,
    logout,
    registerB2bUser,
    sendSecurityQuestions,
    resetB2bPass,
    getRelationships
  };
};
export default useAuthStore;
